// src/pages/InvitationResponse.jsx
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const InvitationResponse = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const action = searchParams.get('action'); // accept or reject
  const [status, setStatus] = useState('processing'); // processing, success, error, expired

  useEffect(() => {
    if (!token || !['accept', 'reject'].includes(action)) {
      setStatus('error');
      return;
    }

    const respond = async () => {
      try {
        const res = await fetch(`${import.meta.env.REACT_APPLICATION_API}/invitation/respond`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token, action }),
        });

        const data = await res.json();

        if (res.ok) {
          setStatus(action === 'accept' ? 'accepted' : 'rejected');
        } else {
          setStatus(data.message?.includes('expired') ? 'expired' : 'error');
        }
      } catch (err) {
        setStatus('error');
      }
    };

    respond();
  }, [token, action]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-white flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center">
        {status === 'processing' && (
          <>
            <div className="animate-spin w-16 h-16 border-4 border-orange-500 border-t-transparent rounded-full mx-auto"></div>
            <h2 className="text-2xl font-bold mt-6">Processing your response...</h2>
          </>
        )}

        {status === 'accepted' && (
          <>
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <span className="text-4xl text-green-600">Checkmark</span>
            </div>
            <h2 className="text-3xl font-bold text-green-600 mt-6">Accepted!</h2>
            <p className="text-gray-600 mt-4">Thank you! The employer has been notified.</p>
          </>
        )}

        {status === 'rejected' && (
          <>
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto">
              <span className="text-4xl text-red-600">Cross</span>
            </div>
            <h2 className="text-3xl font-bold text-red-600 mt-6">Declined</h2>
            <p className="text-gray-600 mt-4">You have declined the invitation.</p>
          </>
        )}

        {status === 'expired' && (
          <>
            <h2 className="text-2xl font-bold text-gray-700">Link Expired</h2>
            <p className="text-gray-600 mt-4">This invitation link is no longer valid.</p>
          </>
        )}

        {status === 'error' && (
          <>
            <h2 className="text-2xl font-bold text-red-600">Invalid Link</h2>
            <p className="text-gray-600 mt-4">This link is not valid or has already been used.</p>
          </>
        )}

        <button
          onClick={() => navigate('/')}
          className="mt-8 px-6 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default InvitationResponse;